import React, { useState }  from "react";
import { navigate } from "gatsby";
import axios from 'axios';
import Main from "../Layout/Main";
import Section from "../Layout/Section/Section";
import InnerContainer from "../Layout/InnerContainer/InnerContainer";
import { handleLogin } from "../../helpers/loginHelper";

import "./login.scss";

const Login = () => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const handlePasswordChange = (e) => {
      e.persist()
      setPassword(e.target.value)
  }

  const handleNameChange = (e) => {
      e.persist()
      setUsername(e.target.value)
  }

  const handleSubmit = event => {
    event.preventDefault()
    if (username !== '') {
      axios({
        url: "/.netlify/functions/vmaPartnerAuth",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: {
          username,
          password
        }
      })
      .then((response) => {
        if (response.data) {
          handleResponse(response.data)
        }
      })
      .catch(error => alert(error));
    }
  }

  const handleResponse = (responseData) => {
    handleLogin(responseData);
    navigate(`/partners/${responseData.userData.path}`)
  }

  return (
    <Main>
      <Section customClass="partners">
        <InnerContainer customClass="partners-login">
          <h1>Login</h1>
          <form id="login" onSubmit={handleSubmit}>
            <input
              className="input"
              placeholder="Username"
              type="text"
              value={username}
              onChange={handleNameChange}
              required
            />
            <input
              className="input"
              placeholder="password"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              required
            />
            <input className="button" type="submit"/>
          </form>
        </InnerContainer>
      </Section>
    </Main>
  )
}

export default Login
